import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { CookieStorage } from 'redux-persist-cookie-storage';

// -------

import Cookies from 'app/services/system/cookie';
import { site } from 'config/app'
import Reducers, { AuthReducer } from 'modules/reducers'
// import PublicSignIn from 'modules/Public/SignIn/store/slice';

// --- persist config
const persistConfig = {
  key: process.env.REACT_APP_CODE || 'westbay:rynelle',
  keyPrefix: 'PERSIST:',
  storage: new CookieStorage(Cookies, {
    setCookieOptions: {
      path: '/',
      maxAge: 60 * 60 * 24 * 7, // 7 days
      secure: ( site.environment === 'production' ),
      sameSite: 'strict',
    },
  }),
  debug: ( site.environment !== 'production' ),
  whitelist: [
    'auth'
  ],
};

const RootPersistedReducer = combineReducers({
  auth: AuthReducer,
  ...Reducers
});

const PersistedReducer = persistReducer(persistConfig, RootPersistedReducer)

export default PersistedReducer;
